"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[296],{

/***/ 2296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ main_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-instagram.js
var uil_instagram = __webpack_require__(3448);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-twitter-alt.js
var uil_twitter_alt = __webpack_require__(1858);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-facebook-f.js
var uil_facebook_f = __webpack_require__(7281);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-youtube.js
var uil_youtube = __webpack_require__(9057);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-phone.js
var uil_phone = __webpack_require__(954);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-whatsapp.js
var uil_whatsapp = __webpack_require__(7870);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/logos.png
var logos = __webpack_require__(2553);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@iconscout/react-unicons/icons/uil-angle-up.js
var uil_angle_up = __webpack_require__(7400);
;// CONCATENATED MODULE: ./components/main/scrollToTop.tsx



const ScrollToTopButton = ()=>{
    const [isVisible, setIsVisible] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handleScroll = ()=>{
            setIsVisible(window.scrollY > 300); // 300px kaydırma durumunda buton görünür
        };
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: scrollToTop,
        name: "moveTop",
        "aria-label": "moveTop",
        className: "fixed bottom-16 right-4 p-1 bg-blue-500 text-white rounded-full shadow-lg transition-opacity duration-300 ".concat(isVisible ? "opacity-100" : "opacity-0"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_angle_up/* default */.Z, {
            size: 20
        })
    });
};
/* harmony default export */ var scrollToTop = (ScrollToTopButton);

;// CONCATENATED MODULE: ./components/main/footer.tsx







const footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto px-4 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt-10 md:grid md:grid-cols-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-2xl font-semibold leading-relaxed md:text-3xl lg:text-4xl text-center md:text-left mb-4",
                                        children: [
                                            " ",
                                            "Bizi her zaman arayabilirsiniz \uD83D\uDC4B"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm font-light md:text-base text-center md:text-left ",
                                        children: "İhtiya\xe7 duyduğunuz her anınızda bizleri arayabilirsiniz, destek ekibimiz 7/24 sizlerle."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "tel:08503466600",
                                        className: "block font-semibold text-3xl pt-0 text-center md:text-right",
                                        children: [
                                            "0850 ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold",
                                                children: "346 66 00"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:info@eticex.com",
                                        className: "text-gray-600 text-lg font-medium text-center md:text-right block leading-10",
                                        children: "info@eticex.com"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 md:grid-cols-4 py-10 md:py-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "font-semibold leading-10 md:leading:10",
                                        children: "E-Ticaret Sistemleri"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "text-sm leading-8 text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/hakkimizda.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Hakkımızda"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/referanslar.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Referanslarımız"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/blog",
                                                    className: "hover:text-orange-600",
                                                    children: "Blog"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/bayilik.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Bayilik"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/banka-hesap-bilgileri.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Banka Hesap Bilgileri"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/iletisim.html",
                                                    className: "hover:text-orange-600",
                                                    children: "İletişim"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "font-semibold leading-10",
                                        children: "\xdcr\xfcn ve Hizmetlerimiz"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "text-sm leading-8 text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/e-ticaret-paketleri.html",
                                                    className: "hover:text-orange-600",
                                                    children: "E-Ticaret Paketleri"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/aylik-e-ticaret-paketleri.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Aylık E-Ticaret Paketleri"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/aylik-e-ticaret-paketleri.html",
                                                    className: "hover:text-orange-600",
                                                    children: "E-Ticaret Paketini Oluştur"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/e-ihracat.html",
                                                    className: "hover:text-orange-600",
                                                    children: "E-İhracat"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/entegrasyonlar.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Entegrasyonlar"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/ozel-tasarim-hizmeti.html",
                                                    className: "hover:text-orange-600",
                                                    children: "\xd6zel Tasarım Hizmetleri"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "font-semibold leading-10",
                                        children: "S\xf6zleşmelerimiz"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "text-sm leading-8 text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/gizlilik-sozlesmesi.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Gizlilik S\xf6zleşmesi"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/mesafeli-satis-sozlesmesi.html",
                                                    className: "hover:text-orange-600",
                                                    children: "Mesafeli Satış S\xf6zleşmesi"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/cerez-politikasi.html",
                                                    className: "hover:text-orange-600",
                                                    children: "\xc7erez Politikası"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/kvkk.html",
                                                    className: "hover:text-orange-600",
                                                    children: "K.V.K.K."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "font-semibold leading-10",
                                        children: "İletişim"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gray-600 text-xs leading-6 block",
                                        children: "Adres,"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "block text-xs leading-5",
                                        children: [
                                            "Kozyatağı, Değirmen Sok. Duranbey İş Merkezi ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " No: 13 D: 5, 34742 Kadık\xf6y/İstanbul"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.instagram.com/eticexcom",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_instagram/* default */.Z, {
                                            className: "inline mt-3 mr-3 w-5",
                                            "aria-label": "Eticex instagram"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://twitter.com/eticex",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_twitter_alt/* default */.Z, {
                                            className: "inline mt-3 mr-3 w-5",
                                            "aria-label": "Eticex Twitter"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://m.facebook.com/eticexcom",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_facebook_f/* default */.Z, {
                                            className: "inline mt-3 mr-3 w-5",
                                            "aria-label": "Eticex Facebook"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://www.youtube.com/channel/UCmmtC1Ip2_7Lti3GedK7cvQ",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_youtube/* default */.Z, {
                                            className: "inline mt-3 mr-3 w-5",
                                            "aria-label": "Eticex Youtube"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "border-t py-3 leading-10 text-xs grid grid-cols-1 md:grid-cols-2 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center md:text-left",
                                children: "Eticex bir Markasis Bilişim A.Ş. iştirakidir."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center md:text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: logos/* default */.Z,
                                    alt: "",
                                    width: "275",
                                    height: "40",
                                    className: "mt-4 md:mt-0 mx-auto md:float-right w-[165px] h-[24px] md:w-[275px] md:h-[40px]"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-transparent md:shadow-none left-0 fixed lg:bottom-[50px] bottom-[0px] py-2 px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "tel:08503466600",
                        className: " border shadow rounded-full px-2 py-1 bg-white ml-0 md:ml-12 cursor-pointer font-semibold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_phone/* default */.Z, {
                                className: "md:h-8 md:w-8 text-green-500 inline"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs ml-2 pr-1",
                                children: "0850 346 66 00"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-transparent md:shadow-none right-0 fixed lg:bottom-[50px] bottom-[0px] py-2 px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-between",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "https://wa.me/908503466600",
                        className: " border shadow l rounded-full px-2 py-1 bg-white mr-0 md:mr-12 cursor-pointer font-semibold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(uil_whatsapp/* default */.Z, {
                                className: "md:h-8 md:w-8 text-green-500 inline"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs ml-2 pr-1",
                                children: "WhatsApp"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollToTop, {})
        ]
    });
};
/* harmony default export */ var main_footer = (footer);


/***/ })

}]);